import { makeFinalRequest, makeGetRequest } from '../general/general-service';
import { services_api_names } from '../general/configs';


export function getListCategory() {
	const finalRequestUrl =  makeFinalRequest(services_api_names.category_list);
	return makeGetRequest(finalRequestUrl);
}
export function getListGenre() {
	const finalRequestUrl =  makeFinalRequest(services_api_names.genre_list);
	return makeGetRequest(finalRequestUrl);
}